import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
    createColorStyles,
    getJobCompensationInfo, getJobSuggestedContentInfo
} from '../common/utilities';

export class Modals extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {
            jobs,
            categories,
            isShowCollegeDegree,
            isShowCompensation,
            isShowRegionalCompensation,
            isShowRegionalSuggestedContent,
            selectedRegion,
            regions,
            labels,
        } = this.props;

        if (!jobs.length) {
            return null;
        }

        // TODO: create separate components for salary, work exp, etc.
        return jobs.map((job, jobIndex) => {
            const cat = categories.filter((cat) => cat.id === job.job_category.id)[0];

            const { isShowCompensationInfo, compensation, regionName } = getJobCompensationInfo({
                isShowCompensation,
                isShowRegionalCompensation,
                job,
                selectedRegion,
                regions,
            });

            const { isShowSuggestedContentInfo, suggestedContent } = getJobSuggestedContentInfo({
                isShowRegionalSuggestedContent,
                job,
                selectedRegion,
                regions,
            });

            return (
                <div
                    key={jobIndex}
                    className="modal-outer-wrapper"
                    id={`modal-${job.id}`}
                    style={createColorStyles(cat)}
                >
                    <div className="modal-inner-wrapper d-table">
                        <div className="d-table-cell">
                            <div className="modal">
                                <header className="modal-header">
                                    <div className="container">
                                        <button className="modal-close js-modal-close">
                                            <span className="show-for-sr">Close modal</span>
                                        </button>

                                        <div className="modal-category">{cat.name}</div>
                                        <h2 className="modal-job-name">{job.name}</h2>
                                    </div>
                                </header>

                                <div className="modal-body">
                                    <div className="modal-top">
                                        <div className="container">
                                            {job.job_description ? (
                                                <>
                                                    <div className="modal-description">
                                                        <div
                                                            dangerouslySetInnerHTML={{ __html: job.job_description }}
                                                        />

                                                        {job.image && job.image.url ? (
                                                            <img src={job.image.url} alt="job image" />
                                                        ) : null}

                                                        {job.indeed_url && (
                                                            <div className="modal-button-wrapper">
                                                                <a
                                                                    href={job.indeed_url}
                                                                    target="_blank"
                                                                    className="modal-button"
                                                                >
                                                                    {this.props.labels?.indeed_btn || 'Search Jobs'}
                                                                </a>
                                                            </div>
                                                        )}
                                                    </div>
                                                </>
                                            ) : null}

                                            <div className="modal-features">
                                                <div className="modal-feature">
                                                    <h3 className="modal-feature-title">
                                                        <i className="icon-education" />

                                                        {this.props.labels?.job_education_title || 'Required Education & Training'}
                                                    </h3>
                                                    <div className="feature-description">
                                                        {isShowCollegeDegree && job.requires_college_degree ? (
                                                            <div className="college">
                                                                <span className="special diamond" /> {this.props.labels?.college_degree || 'College Degree'}
                                                            </div>
                                                        ) : (
                                                            'High School Diploma or Equivalent'
                                                        )}

                                                        {job.college_degree_description ? (
                                                            <div className="college-description">{job.college_degree_description}</div>
                                                        ) : null}
                                                    </div>
                                                </div>

                                                {job.work_experience && (
                                                    <div className="modal-feature">
                                                        <h3 className="modal-feature-title">
                                                            <i className="icon-experience" />

                                                            {this.props.labels?.job_experience_title || 'Work Experience'}
                                                        </h3>
                                                        <div className="feature-description">{job.work_experience}</div>
                                                    </div>
                                                )}

                                                {isShowCompensationInfo && (
                                                    <div className="modal-feature">
                                                        <h3 className="modal-feature-title">
                                                            <i className="icon-pay" />
                                                            {this.props.labels?.job_pay_title || 'Pay'}
                                                        </h3>
                                                        <div className="feature-description">
                                                            {compensation.salary && compensation.salary.low_end && compensation.salary.high_end ? (
                                                                <div className="price annual">
                                                                    {compensation.salary.low_end} - {compensation.salary.high_end} / {this.props.labels?.salary_year || 'year'}
                                                                </div>
                                                            ) : null}

                                                            {compensation.hourly && compensation.hourly.low_end && compensation.hourly.high_end ? (
                                                                <div className="price hour">
                                                                    {compensation.hourly.low_end} - {compensation.hourly.high_end} / {this.props.labels?.salary_hour || 'hour'}
                                                                </div>
                                                            ) : null}

                                                            {compensation.grade ? (
                                                                <div className="price grade">
                                                                    {compensation.grade}
                                                                </div>
                                                            ) : null}

                                                            {regionName ? <p className="price">{regionName}</p> : null}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="modal-bottom">
                                        <div className="container">
                                            {job.skills_requirements && job.skills_requirements.length ? (
                                                <div className="modal-feature skills">
                                                    <h3 className="modal-feature-title">
                                                        <i className="icon-skills" />
                                                        {this.props.labels?.job_skills_title || 'Skills & Requirements'}
                                                    </h3>
                                                    <ul className="modal-list">
                                                        {typeof job.skills_requirements === 'string'
                                                            ? job.skills_requirements
                                                                // eslint-disable-next-line
                                                                .split("\n")
                                                                .map((skill, skillIndex) =>
                                                                    skill.length
                                                                        ? (<li dangerouslySetInnerHTML={{ __html: skill }} key={skillIndex} />)
                                                                        : null
                                                                )
                                                            : job.skills_requirements.map((skill, skillIndex) => (
                                                                <li key={skillIndex}>{skill}</li>
                                                            ))}
                                                    </ul>
                                                </div>
                                            ) : null}

                                            { isShowSuggestedContentInfo ? (
                                                <div className="modal-feature learning-material">
                                                    <h3 className="modal-feature-title">
                                                        <i className="icon-course" />
                                                        {this.props.labels?.job_training_resources_title || 'Training Programs & Resources'}
                                                    </h3>
                                                    <ul className="modal-list">
                                                        {suggestedContent.map((content, contentIndex) => (
                                                            <li key={contentIndex}>
                                                                <a target={content.url ? '_blank' : '_self'} href={content.url || '#'}>
                                                                    {content.name}
                                                                </a>
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </div>
                                            ) : null}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        });
    }
}

Modals.propTypes = {
    jobs: PropTypes.array.isRequired,
    categories: PropTypes.array.isRequired,
    isShowCollegeDegree: PropTypes.bool.isRequired,
    isShowCompensation: PropTypes.bool.isRequired,
    selectedRegion: PropTypes.number,
};
